import React from 'react';
import NavBar from "../Layouts/NavBar";
import Container from "../Layouts/Container";
import Certifications from "./certifications";
import Projects from "./projects";
import Contact from "./contact";

export default function Home () {
  return (
    <div id="create-test">
      <NavBar/>
      <Container>
        <div className="col-12 flex center">
          <div className="col-12 col-md-10 col-lg-8">
            <a href="#about" name="about"><h1>About</h1></a>
            <p>
              I am currently an undergrad student of Delhi Technological University (Delhi College of Engineering).
              And this is the place where I have put relevant information about me.
              <br/ >
              I am a self-taught innovative programmer. I like to create things, build websites, solve problems and write clean and readable code. I love C++ and Python. JavaScript is also one of my favorite languages (who doesn't love functional programming, right?).
              I am currently working on a web development project and reshaping my programming skills with competitive programming. I am also an enthusiastic learner of machine learning algorithms and have implemented them in python from Gradient Descent to Decision Trees from core.
            </p>

            <a href="#projects" name="projects"><h1 name="#projects">Projects</h1></a>
            <Projects />
            
            <a href="#skills" name="skills"><h1>Skills</h1></a>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>Programming languages</td>
                    <td>C++, Python, JavaScript</td>
                  </tr>
                  <tr>
                    <td>Data Science</td>
                    <td>Classification, Neural Networks, Recommender System, SVM</td>
                  </tr>
                  <tr>
                    <td>Web Development</td>
                    <td>HTML5, CSS3, NodeJS, React, ajax, PWA, Docker, Bootstrap, Material-UI</td>
                  </tr>
                  <tr>
                    <td>Databases</td>
                    <td>MySQL, MongoDB</td>
                  </tr>
                  <tr>
                    <td>Other Skills</td>
                    <td>Git, STL, NumPy, Pandas, Matplotlib, Google-Charts, Scikit-learn, LaTex </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
            <a href="#experience" name="experience"><h1>Experience</h1></a>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>Sept - Dec, 2018</td>
                    <td>
                      <strong style={{"fontSize":"1.4em"}}>Delhi Technological University</strong>
                      <br/>University Student Internship Program <br />
                      Training and Placement Cell
                      
                      <br/>
                    </td>
                  </tr>
                  <tr>
                    <td>June - July, 2018</td>
                    <td>
                      <strong style={{"fontSize":"1.4em"}}>India Yamaha Motor Pvt. Ltd.</strong>
                      <br/>
                      Summer Intern in Product Quality Department
                      <br/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <a href="#education" name="education"><h1>Education</h1></a>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>2017-2021</td>
                    <td>
                      <strong style={{"fontSize":"1.4em"}}>Delhi Technological University</strong>
                      <br/>
                      Mechanical Engineering
                      <br/>
                      <strong>GPA: 7.87</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>2014-2016</td>
                    <td>
                      Intermediate (PCM & CS)
                      <br/>
                      DAV Public School, Sreshtha Vihar (CBSE)
                      <br/>
                      <strong>93.2%</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>2012-2014</td>
                    <td>
                      High School
                      <br/>
                      (CBSE)
                      <br/>
                      <strong>CGPA: 10.0</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <a href="#certifications" name="certifications"><h1>Certifications</h1></a>
            <div>
              <Certifications />
            </div>


            <a href="#contact" name="contact"><h1>Contact & Social Info</h1></a>
            <Contact />

            <a href="#interests" name="interests"><h1>Interests</h1></a>
            <div>
              <h3>Competitive Programming</h3>
              <h3>Web Development</h3>
              <h3>Machine Learning</h3>
              <h3>Data Analysis</h3>
              <h3>Robotics</h3>
              <h3>Mathematics</h3>
            </div>

          </div>
        </div>
      </Container>
    </div>
  )
}